<template>
  <section class="medbisOrderPage pt-8 mx-auto w-10/12">
    <div class="row">
      <div class="col-xs-6">
        <v-heading :level="1">
        Bestellen voor uw instelling of praktijk
        </v-heading>
      </div>
    </div>
    <div class="row">
      <div class="medbisOrderPage__block col-xs-12">
        <v-header :title="'Mijn MedBis'" />
        <legend>Ontdek hoe eenvoudig het bestellen voor uw instelling of praktijk is via Mijn MedBis. Mijn MedBis is een bestel- en informatieservice van Mediq waar u medische voeding en hulpmiddelen voor uw bewoners kunt bestellen. Maar ook voor uw praktijk.</legend>
        <div class="medbisOrderPage__submit">
          <v-button primary md tagelement="button" @click.prevent="goToMedBIS()">
           Naar Mijn MedBis
          </v-button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import VHeader from '@/components/shared/Header.vue';
import axios from 'axios';

export default {
  name: 'MedbisOrderPage',
  components: {
    VHeader
  },
  data() {
    return {
      
    };
  },
  computed: {},
  created() {
   
  },
  methods: {
    goToMedBIS() {
      window.open('https://medbis.mediq.nl/user/login');
    }
  }
};
</script>
<style lang="scss" scoped>
.medbisOrderPage {
  &__block {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: $white;
    margin: 20px 0px 20px 0px;
    padding: 0px 0px 30px 0px;
    legend {
      margin: 15px 15px 15px 40px;
      font-size: 16px;
    }
  }
  &__submit {
    margin: 10px 0px 0px 40px;
  }
}
</style>
